import { render, staticRenderFns } from "./InformationExchange.vue?vue&type=template&id=d5a9a426&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./InformationExchange.vue?vue&type=script&lang=js&"
export * from "./InformationExchange.vue?vue&type=script&lang=js&"
import style0 from "./InformationExchange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InformationExchange.vue"
export default component.exports